import { render } from "./SettingDashboard.vue?vue&type=template&id=d173c5ec&scoped=true"
import script from "./SettingDashboard.vue?vue&type=script&lang=js"
export * from "./SettingDashboard.vue?vue&type=script&lang=js"

import "./SettingDashboard.vue?vue&type=style&index=0&id=d173c5ec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d173c5ec"]])

export default __exports__